import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { FONT_FAMILY } from "../../constants/appConfig";

export const Card = ({ children, style = {}, onClick, hoverable = false }) => {
  const { palette } = useApp();
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: palette.cardBg,
        border: `1px solid ${palette.cardBorder}`,
        borderRadius: 12, padding: 20,
        backdropFilter: "blur(10px)",
        transition: "all 0.2s",
        cursor: onClick ? "pointer" : "default",
        transform: hoverable && isHovered ? "translateY(-2px)" : "translateY(0)",
        boxShadow: hoverable && isHovered ? "0 8px 24px rgba(0,0,0,0.12)" : "0 2px 8px rgba(0,0,0,0.04)",
        fontFamily: FONT_FAMILY,
        ...style
      }}
    >{children}</div>
  );
};
